import { combineReducers } from 'redux';

import sessionReducer from './sessionReducer';
import notifierReducer from './notifierReducer';
import usersReducer from '../views/Management/reducers/UsersReducer';
import operatorsReducer from '../views/Management/reducers/OperatorsReducer';
import settingsReducer from '../views/Management/reducers/SettingsReducer';
import dashboardInspectReducer from '../views/Dashboard/reducers/DashboardInspectReducer';
import mapReducer from '../components/Map/reducers/MapReducer';
import incidentTrackerReducer from '../views/IncidentTracker/reducers/IncidentTrackerReducer';
import reportsReducer from '../views/ReportKpis/reducers/ReportsReducer';
import siteTrackerReducer from '../views/SiteTracker/reducers/SiteTrackerReducer';
import weeklyReportReducer from '../views/WeeklyReport/reducers/WeeklyReportReducer';
import streetScapeTrackerReducer from '../views/StreetScapeTracker/reducers/StreetScapeTrackerReducer';

const rootReducer = combineReducers({
	session: sessionReducer,
	usersReducer,
	notifierReducer,
	operatorsReducer,
	settingsReducer,
	dashboardInspectReducer,
	mapReducer,
	incidentTrackerReducer,
	reportsReducer,
	siteTrackerReducer,
	weeklyReportReducer,
	streetScapeTrackerReducer
});

export default rootReducer;
